import {
	EstimatedSubtotalCard,
	EstimatedSubtotalContainer,
	EstimatedSubtotalInnerContainer,
	EstimatedSubtotalTextBold,
	EstimatedSubtotalTextSmall
} from "components/NewOrders/ViewPriceEstimates/viewPriceEstimates.styles";
import { CustomQuotePricingText, EstimatedSubtotalText, NetAcknowledgementHelperText } from "../constants";
import { useSelector } from "react-redux";
import { RootState } from "stores/application.store.tsx";
import { containsCustomQuoteSku } from "../utils/NewOrderUtils.tsx";
import { useMemo } from "react";
import { formatPriceWithPrefix } from "utils/string.ts";
import {
	AcknowledgementType,
	getListAcknowledgementHelperText,
	getPromotionalPricingText
} from "pages/OrderPages/utils/OrderDetailUtil.ts";
import { NoChargeOrderText } from "constants/text.ts";

interface EstimatedSubTotalProps {
	pricing: number | null | undefined;
	acknowledgementType?: AcknowledgementType;
	subtotalTitle?: string;
	isReplacement?: boolean;
	isNewQuoteOrder?: boolean;
}

const EstimatedSubtotal = ({
	pricing,
	acknowledgementType = AcknowledgementType.NO_ACKNOWLEDGEMENT,
	subtotalTitle = EstimatedSubtotalText,
	isNewQuoteOrder,
	isReplacement = false
}: EstimatedSubTotalProps) => {
	const validatedOrderResponse = useSelector((state: RootState) => state.newOrder.validatedOrderResponse);
	const customQuotePricingText = useMemo(
		() => containsCustomQuoteSku(validatedOrderResponse) && CustomQuotePricingText,
		[validatedOrderResponse]
	);
	return (
		<EstimatedSubtotalCard>
			<EstimatedSubtotalContainer>
				<EstimatedSubtotalInnerContainer>
					<EstimatedSubtotalTextBold>
						{isNewQuoteOrder ? "Estimated Quote" : subtotalTitle}
					</EstimatedSubtotalTextBold>
					<div data-testid="view-price-estimate-estimated-subtotal">
						{formatPriceWithPrefix(isReplacement ? 0 : pricing, false, true)}
					</div>
				</EstimatedSubtotalInnerContainer>
				<EstimatedSubtotalTextSmall>
					{isReplacement ? (
						<>
							{customQuotePricingText}
							{NoChargeOrderText}
						</>
					) : (
						!isNewQuoteOrder && (
							<>
								{acknowledgementType === AcknowledgementType.NET_ACKNOWLEDGEMENT &&
									NetAcknowledgementHelperText}
								{customQuotePricingText}
								{getListAcknowledgementHelperText(acknowledgementType, subtotalTitle)}
								{!customQuotePricingText &&
									getPromotionalPricingText(acknowledgementType, subtotalTitle)}
							</>
						)
					)}
				</EstimatedSubtotalTextSmall>
			</EstimatedSubtotalContainer>
		</EstimatedSubtotalCard>
	);
};

export default EstimatedSubtotal;
